import { Link } from "react-router-dom";

export const ConsentBanner = ({ accept, reject, customize }) => (
    <section className="cookie-banner" role="region" aria-label="Scelte sui cookie" data-testid="cookie-banner">
        <div className="container cookie-banner-inner">
            <div className="cookie-banner-copy">
                <h2 data-testid="cookie-banner-title">I cookie, alle tue condizioni.</h2>
                <p data-testid="cookie-banner-description">Usiamo strumenti tecnici necessari. Statistiche e pubblicità di Google, Meta e TikTok solo con il tuo consenso, se configurati. Puoi rifiutare senza rinunciare al sito. <Link to="/cookie" data-testid="cookie-banner-policy">Informativa cookie</Link>.</p>
            </div>
            <div className="cookie-actions">
                <button type="button" onClick={reject} data-testid="cookie-reject-all">Rifiuta non necessari</button>
                <button type="button" onClick={customize} data-testid="cookie-customize">Personalizza</button>
                <button type="button" onClick={accept} data-testid="cookie-accept-all">Accetta tutti</button>
            </div>
        </div>
    </section>
);